import { requirementOptions } from '@/apps/job_post/requirements/types/requirementsOptions';
import { responsibilityOptions } from '@/apps/job_post/requirements/types/responsibilitiesOptions';
import { languageOptions } from '@/apps/job_post/requirements/types/languageOptions';

function mapValuesToLabels(values: string[], options: any[]): string[] {
  return values.map((value) => options.find((opt) => opt.value === value)?.textLabel).filter(Boolean) as string[];
}

export default function formatJobDetails(jobState: {
  requirements: string[];
  responsibilities: string[];
  languages: string[];
}): string[] {
  return [
    ...mapValuesToLabels(jobState.requirements, requirementOptions),
    ...mapValuesToLabels(jobState.responsibilities, responsibilityOptions),
    ...mapValuesToLabels(jobState.languages, languageOptions),
  ];
}
